import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import { useEffect } from "react";

type MaxLengthReadOnlyPluginProps = {
  maxLength?: number;
};

export const MaxLengthReadOnlyPlugin = ({
  maxLength,
}: MaxLengthReadOnlyPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      const root = $getRoot();
      const content = root.getTextContent();

      if (maxLength !== undefined && content.length > maxLength) {
        root.clear();

        const paragraph = $createParagraphNode();
        paragraph.append($createTextNode(content.slice(0, maxLength) + "..."));
        root.append(paragraph);
      }
    });
  }, [editor, maxLength]);

  return null;
};
